import axios, { AxiosInstance } from 'axios';
import config from './config';
import setupInterceptorsTo from './interceptors/authorizationInterceptor';

const BASE_CONFIG = {
  baseURL: config.ApiUrl,
  headers: { 'Content-type': 'application/json' },
};

export const clientWithAuth: AxiosInstance = setupInterceptorsTo(axios.create(BASE_CONFIG));
export const clientWithoutAuth: AxiosInstance = axios.create(BASE_CONFIG);
